import React from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import * as queryString from 'query-string';
import { convertHighlightToHighlightInput } from '../../../utils/inputTransform';
import { Highlight } from '../../../utils/types';

const DebugPanel: React.FC<DebugPanelProps> = ({ highlight }) => {
	const { search } = useLocation();
	const { debug } = queryString.parse(search);

	if (!debug) return null;

	return (
		<Grid item xs={12}>
			<Card>
				<CardHeader title='Debug output' />
				<CardContent>
					<pre>{JSON.stringify(convertHighlightToHighlightInput(highlight), null, 4)}</pre>
				</CardContent>
			</Card>
		</Grid>
	);
};

type DebugPanelProps = { highlight: Highlight };

export default DebugPanel;
